module.exports = __webpack_public_path__ + "static/js/0.5916d959.chunk.worker.js"